import React, { Fragment, useState, useEffect } from 'react';
import Grid from "../../Grid";
import Button from "../../Button";
import { useForm } from 'react-hook-form';
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';
import styles from './Form.module.sass'
import axios from 'axios';

const Form = ({ type, value, id }) => {
  const { register, handleSubmit, control, trigger, watch, setValue, unregister, formState: { errors } } = useForm();
  const watchNote = watch("note");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setValue('note', value)
  }, []);

  const onSubmit = (data) => {
    setIsSubmitting(true);
    axios
      .patch(`/admin/photographer_notes/${id}`, { photographer_note: { note: data.note, note_type: type } })
      .then(() => window.location.href = `/admin/photographer_notes?type=${type}`);
  }

  return (
    <Fragment>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container justify='center' spacing={2}>
          <textarea
            className={styles.input}
            {...register("note", { required: true })}
          />
        </Grid>

        <Button
          classes={styles.submit}
          variant='submit'
          disabled={!watchNote}
        >
          Update Note
        </Button>
      </form>
    </Fragment>
  )
}

export default Form;
